import React from "react";
import { Col, Row } from "react-bootstrap";
import Cookies from "js-cookie";
import BackHistory from "@/containers/BackHistory/BackHistory";
import SntBrowserTabTitle from "@cleanup/components/SntBrowserTabTitle";
import SntHideLongText from "@/components/ReactBootstrap/SntHideLongText";

interface ActionHeaderProps {
  title: string;
  tabTitle?: string;
  renderHeaderIcon?: () => React.ReactNode;
  toolbar?: React.ReactNode;
  /** Back arrow is opt-in: only detail/drill-in pages enable it (STIC-15588). */
  isShowBackHistory?: boolean;
  /**
   * Canonical parent route for the back arrow when the page is opened
   * without in-app history (direct URL / bookmark). See BackHistory.
   */
  backTo?: string;
  /**
   * Second row under the title (the owner line of a detail page). Switches
   * the header to PageHeader's grid layout so the row lines up under the
   * title text, after the back arrow.
   */
  subtitle?: React.ReactNode;
}

const ActionHeader: React.FC<ActionHeaderProps> = ({
  title,
  tabTitle,
  renderHeaderIcon,
  toolbar,
  isShowBackHistory = false,
  backTo,
  subtitle,
}) => {
  const sensolusFullScreen = Cookies.get("sensolus-full-screen");

  if (sensolusFullScreen) return <></>;

  if (subtitle) {
    return (
      <Row>
        <Col xs="12">
          <SntBrowserTabTitle title={tabTitle || title} />

          <div
            className="heading"
            style={{
              display: "grid",
              gridTemplateColumns: "auto minmax(0, 1fr)",
              alignItems: "center",
              paddingTop: 8,
              paddingBottom: 8,
            }}
          >
            <div style={{ gridColumn: 1 }}>{isShowBackHistory && <BackHistory backTo={backTo} />}</div>
            <div className="d-flex justify-content-between" style={{ gridColumn: 2, minWidth: 0 }}>
              <div className="d-flex align-items-center w-50">
                <h1 className="page-header mb-0" style={{ marginTop: 0, minWidth: 0, overflow: "hidden" }}>
                  <SntHideLongText>{title}</SntHideLongText>
                </h1>
                {renderHeaderIcon && renderHeaderIcon()}
              </div>
              <div className="d-flex justify-content-end align-items-center w-50">
                {toolbar && toolbar}
              </div>
            </div>
            <div className="d-flex align-items-center flex-wrap" style={{ gridColumn: 2, marginTop: 8 }}>
              {subtitle}
            </div>
          </div>
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col xs="12">
        <SntBrowserTabTitle title={tabTitle || title} />

        <div className="d-flex justify-content-between heading">
          <div className="d-flex align-items-center w-50">
            {isShowBackHistory && <BackHistory backTo={backTo} />}
            <h1 className="page-header">
              <SntHideLongText>{title}</SntHideLongText>
            </h1>
            {renderHeaderIcon && renderHeaderIcon()}
          </div>
          <div className="d-flex justify-content-end align-items-center w-50">
            {toolbar && toolbar}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ActionHeader;
